<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Profil Użytkownika</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-form ref="user">
                  <v-text-field v-model="firstname"
                    label="Imię"
                    name="firstname"
                    :value="userInfo.firstname"
                    :disabled="admin"
                    :error-messages="errors.firstName"
                  ></v-text-field>
                  <v-text-field v-model="lastname"
                    label="Nazwisko"
                    name="lastname"
                    :value="userInfo.lastname"
                    :disabled="admin"
                    :error-messages="errors.lastName"
                  ></v-text-field>
                  <v-text-field v-model="email"
                    label="E-mail"
                    name="email"
                    :value="userInfo.email"
                    :disabled="admin"
                    :error-messages="errors.email"
                  ></v-text-field>
                  <v-text-field v-model="phone"
                      label="Telefon"
                      name="phone"
                      :value="userInfo.phone"
                      v-if="!admin"
                  ></v-text-field>
                  <v-text-field v-model="pwz"
                      label="PWZ"
                      name="pwz"
                      :value="userInfo.pwz"
                      v-if="!admin"
                  ></v-text-field>
                  <p class="mt-10">Status:</p>
                  <template v-if="admin">
                    <v-radio-group v-model="active" row>
                      <v-radio
                        name="active"
                        label="Aktywny"
                        :value="true"
                      ></v-radio>
                      <v-radio
                        name="active"
                        label="Nieaktywny"
                        :value="false"
                      ></v-radio>
                    </v-radio-group>
                  </template>
                  <template v-else>
                    <v-radio-group v-model="verify" row>
                      <v-radio
                        name="verify"
                        label="Aktywny"
                        :value="true"
                      ></v-radio>
                      <v-radio
                        name="verify"
                        label="Nieaktywny"
                        :value="false"
                      ></v-radio>
                    </v-radio-group>
                  </template>
                  <template v-if="admin">
                    <p>Rola:</p>
                    <v-radio-group v-model="role" row>
                      <v-radio
                        name="role"
                        label="Admin"
                        :value="false"
                      ></v-radio>
                      <v-radio
                        name="role"
                        label="Super Admin"
                        :value="true"
                      ></v-radio>
                    </v-radio-group>
                  </template>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <template v-if="userInfo.firstname && admin">
            <v-btn color="primary darken-1" @click="resetPassword(userInfo.id)">
              Zresetuj hasło
            </v-btn>
          </template>
          <template v-if="userInfo.firstname && !admin && !userInfo.confirmed">
            <v-btn color="primary darken-1" @click="confirmEmail(userInfo.id)">
              Ręcznie potwierdź maila
            </v-btn>
          </template>
          <v-spacer></v-spacer>
          <v-btn color="error darken-1" @click="close()">
            Zamknij
          </v-btn>
          <v-btn
            color="success darken-1"
            @click="
              admin
                ? saveAdmin(userInfo.id, active, role)
                : saveDoctor(userInfo.id, firstname, lastname, email, phone, pwz, verify)
            "
          >
            Zapisz
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { validationMixin } from "vuelidate";
import axiosConf from "../axios-conf";

export default {
  mixins: [ validationMixin ],
  props: {
    open: Boolean,
    admin: Boolean,
    userInfo: Array[Object]
  },
  data() {
    return {
      firstname: null,
      lastname: null,
      email: null,
      phone: null,
      pwz: null,
      verify: null,
      active: null,
      role: null,
      dialog: false,
      errors: {
        firstName: [],
        lastName: [],
        email: [],
        phone: [],
        pwz: [],
      },
      messages: null,
    };
  },
  watch: {
    open(newVal) {
      this.dialog = newVal;
      // this.errors = {
      //   firstname: [],
      //   lastname: [],
      //   email: [],
      //   phone: [],
      //   pwz: []
      // }
      for(let fields of Object.keys(this.errors)){
        this.errors[fields].splice(0, this.errors[fields].length)
      }
    },
    userInfo(newVal) {
      this.firstname = newVal.firstname;
      this.lastname = newVal.lastname;
      this.email = newVal.email;
      this.phone = newVal.phone;
      this.pwz = newVal.pwz;
      this.verify = newVal.verify;
      this.active = newVal.active;
      this.role = newVal.role;
    }
  },
  methods: {
    close() {
      this.dialog = false;
      this.$emit("close", "close");
    },
    saveAdmin(id, active, role) {
      this.dialog = false;
      this.changeAdminOptions(id, active, role);
    },
    saveDoctor(id, firstname, lastname, email, phone, pwz, verify) {
      this.changeDoctorOptions(id, firstname, lastname, email, phone, pwz, verify);
    },
    changeAdminOptions(id, active, role) {
      axiosConf
        .post(
          `administrator/${id}/edit.json`,
          {
            active: active,
            role: role
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("loggedIn")}`
            }
          }
        )
        .then(response => {
          if (response.status === 200) {
            this.$emit("close", true);
          } else {
            this.$emit("close", false);
          }
        });
    },
    changeDoctorOptions(id, firstname, lastname, email, phone, pwz, verify) {
      axiosConf
        .post(
          `doctor/${id}/edit.json`,
          {
            firstName: firstname,
            lastName: lastname,
            email: email,
            phone: phone,
            pwzNumber: pwz,
            isVerified: verify
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("loggedIn")}`
            }
          }
        )
        .then(response => {
          if (response.status === 200) {
            this.$emit("close", true);
            this.close();
          }
        })
        .catch((error) => {
          const errors = error.response.data.errors;
          for(let field of Object.keys(errors)){
            for(let error of errors[field]){
              if(this.errors[field]) {
                this.errors[field].push(error)
              }
            }
          }
        });
    },
    confirmEmail(id){
      axiosConf
          .post(
              `doctor/${id}/confirm.json`,
              {},
              {
                headers: {
                  Authorization: `Bearer ${sessionStorage.getItem("loggedIn")}`
                }
              }
          )
          .then(response => {
            if (response.status === 200) {
              this.$emit("close", true);
            } else {
              this.$emit("close", false);
            }
          });
      this.close();
    },
    resetPassword(id) {
      axiosConf
        .post(
          `/administrator/reset-password.json`,
          {
            id: id
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("loggedIn")}`
            }
          }
        )
        .then(response => {
          if (response.status === 200) {
            this.$emit("close", true);
          } else {
            this.$emit("close", false);
          }
        });
      this.close();
    }
  }
};
</script>
